// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PersonCategory_Wrapper__pP0Qe"};